
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUnknownobject as ObiUnknownobjectElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-unknownobject.js';
 
 
 

 
 export const ObiUnknownobject = createComponent({
   react: React,
   tagName: 'obi-unknownobject',
   elementClass: ObiUnknownobjectElement,
   events: {
     
   }
  });
 
 